import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { fmtDag } from '@ep/core';
import { api } from '../lib/api';
import { toast } from '../ui/toast';
import { getal, Veld } from '../ui/ui';

interface Info { titel: string; project: string | null; klant: string | null; changeNr: string | null; engineer: string | null; startdatum: string | null; einddatum: string | null; van: string | null; tot: string | null; terugmelding: string | null; tmDatum: string | null }

const KEUZES = [
  ['KLAAR', '✓ Klaar', 'Het werk is af'],
  ['NIET_KLAAR', '⏳ Niet klaar', 'Er is nog werk nodig'],
  ['HERPLANNEN', '🔁 Herplannen', 'Kon niet doorgaan, opnieuw plannen'],
] as const;

/** Terugmelden zonder in te loggen (link uit de afspraak of de herinneringsmail). */
export function Terugmelden() {
  const { token } = useParams();
  const [q] = useSearchParams();
  const info = useQuery({ queryKey: ['tm', token], queryFn: () => api.get<Info>(`/api/terugmelden/${token}`), retry: false });
  const [keuze, setKeuze] = useState<string>(q.get('k') ?? '');
  const [opm, setOpm] = useState('');
  const [rest, setRest] = useState('');
  const [voorkeur, setVoorkeur] = useState('');
  const [klaar, setKlaar] = useState(false);
  const verstuur = async () => {
    try {
      await api.post(`/api/terugmelden/${token}`, { terugmelding: keuze, opmerking: opm || null, restUren: getal(rest), voorkeur: voorkeur || null });
      setKlaar(true);
    } catch (e) {
      toast((e as Error).message, 'fout');
    }
  };
  return (
    <div className="midden">
      <div className="paneel login kolom" style={{ maxWidth: 520 }}>
        <div className="rij"><img src="/favicon.svg" width={30} alt="" /><h2>Terugmelden</h2></div>
        {info.isLoading && <div className="mute">Laden…</div>}
        {info.error && <div style={{ color: 'var(--rood)' }}>{(info.error as Error).message}</div>}
        {info.data && !klaar && (
          <>
            <div className="paneel vlak">
              <b>{info.data.titel}</b>
              <div className="klein mute">
                {[info.data.project, info.data.changeNr, info.data.klant].filter(Boolean).join(' · ')}
                <br />
                {fmtDag(info.data.startdatum, 'lang')}
                {info.data.einddatum && info.data.einddatum !== info.data.startdatum ? ` t/m ${fmtDag(info.data.einddatum, 'lang')}` : ''} · {info.data.van}–{info.data.tot} · {info.data.engineer}
              </div>
              {info.data.terugmelding && <div className="klein" style={{ marginTop: 6, color: 'var(--oranje)' }}>Al teruggemeld; je kunt het hieronder aanpassen.</div>}
            </div>
            <div className="kolom">
              {KEUZES.map(([k, l, u]) => (
                <button key={k} className={`knop ${keuze === k ? 'aan' : ''}`} style={{ justifyContent: 'flex-start', padding: 12 }} onClick={() => setKeuze(k)}>
                  <b>{l}</b> <span className="mute klein">– {u}</span>
                </button>
              ))}
            </div>
            {keuze && keuze !== 'KLAAR' && (
              <div className="grid2">
                <Veld label="Hoeveel uur is er nog nodig?"><input value={rest} onChange={(e) => setRest(e.target.value)} /></Veld>
                <Veld label="Voorkeursdatum"><input type="date" value={voorkeur} onChange={(e) => setVoorkeur(e.target.value)} /></Veld>
              </div>
            )}
            {keuze && <Veld label="Opmerking (optioneel)"><textarea value={opm} onChange={(e) => setOpm(e.target.value)} /></Veld>}
            <button className="knop primair" disabled={!keuze} onClick={verstuur}>Versturen</button>
          </>
        )}
        {klaar && <div style={{ fontSize: 16 }}>✅ Bedankt! Je terugmelding is opgeslagen. Je kunt dit venster sluiten.</div>}
      </div>
    </div>
  );
}
